import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BonnetClosedFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M4.04004 17.0649L4.04139 17.0614H11.6497C12.9307 20.0009 16.6727 19.3153 17.4014 17.0614H18.1974C19.2436 17.0872 19.9778 16.1731 19.9778 15.2467V13.9081L19.9774 13.8959C19.6235 10.9043 17.769 10.5609 13.9741 9.85817L13.6932 9.8061L10.7439 8.14725C9.80146 7.56609 8.72224 7.2583 7.62109 7.2583L4.04004 7.25908V17.0649Z"
      />
    </SvgIcon>
  );
});
